import * as React from 'react';
import {
    ViewContextType,
    ViewContextTypes
}                 from '../MessageTemplatesList/MessageTemplatesListTypes';
import icons      from '../../icons';

interface InputViewToggleProps {
    inputView: ViewContextType;
    handleChangeInputView: (event: React.SyntheticEvent<{ value: string }>) => void;
}

const InputViewToggle: React.StatelessComponent<InputViewToggleProps> = ({ inputView, handleChangeInputView }) => (
    <div className="messagesInputToggle">
        <div className="messagesInputToggle_inputGroup">
            <input className="messagesInputToggle_input" type="radio" id={ViewContextTypes.MESSAGES_INPUT} value={ViewContextTypes.MESSAGES_INPUT} onChange={handleChangeInputView} checked={inputView === ViewContextTypes.MESSAGES_INPUT} />
            <label className="messagesInputToggle_label" htmlFor={ViewContextTypes.MESSAGES_INPUT}>{inputView === ViewContextTypes.MESSAGES_INPUT ? icons.templatesActive : icons.templatesInactive}</label>
        </div>
        <div className="messagesInputToggle_inputGroup">
            <input className="messagesInputToggle_input" type="radio" id={ViewContextTypes.DEFAULT} value={ViewContextTypes.DEFAULT} onChange={handleChangeInputView} checked={inputView === ViewContextTypes.DEFAULT} />
            <label className="messagesInputToggle_label" htmlFor={ViewContextTypes.DEFAULT}>{inputView === ViewContextTypes.DEFAULT ? icons.inputActive : icons.inputInactive}</label>
        </div>
    </div>
);

export default InputViewToggle;



// WEBPACK FOOTER //
// ./src/sections/MessagesInput/InputViewToggle.tsx